import { Divider, styled, Typography } from "~/common/mui";
import React from "react";
import Parameter from "~/common/components/Parameter";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import {
  STEP_1_FIELDS,
  STEP_2_FIELDS,
} from "~/features/registration/components/CustomerRegistrationPage/registrationFormFields";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";

interface Props {
  sectors: Record<string, string>;
  jobTitles: Record<string, string>;
}

export const Step3 = (props: Props) => {
  const { t } = useTranslation();
  const title = (label: string) => (
    <Typography variant={"titleLarge"} sx={{ fontWeight: "bold" }}>
      {label}
    </Typography>
  );
  const formData = useFormContext().getValues();
  return (
    <>
      <SummaryContainer>
        <SummaryColumn>
          {title("Company Information")}
          {STEP_1_FIELDS.map((key) => (
            <>
              {key === "sector" && (
                <Parameter label={t(`page.selfRegistration.field.${key}.label`)}>
                  {t(props.sectors[formData[key]])}
                </Parameter>
              )}
              {key === "country" && (
                <Parameter label={t(`page.selfRegistration.field.${key}.label`)}>
                  {t(`country.${formData[key]}translation`)}
                </Parameter>
              )}
              {key !== "sector" && key !== "country" && (
                <Parameter label={t(`page.selfRegistration.field.${key}.label`)}>{formData[key] || "-"}</Parameter>
              )}
            </>
          ))}
        </SummaryColumn>
        <SummaryColumn>
          {title("Personal information")}
          {STEP_2_FIELDS.filter((key) => key !== "marketingConsent").map((key) => (
            <>
              {key === "jobTitle" && (
                <Parameter label={t(`page.selfRegistration.field.${key}.label`)}>
                  {t(props.jobTitles[formData[key]])}
                </Parameter>
              )}
              {key !== "jobTitle" && (
                <Parameter label={t(`page.selfRegistration.field.${key}.label`)}>{formData[key] || "-"}</Parameter>
              )}
            </>
          ))}
        </SummaryColumn>
      </SummaryContainer>
    </>
  );
};

const SummaryContainer = styled(({ children, ...props }: JSX.IntrinsicElements["div"]) => {
  const childrenCount = React.Children.count(children);
  const isMinTablet = useIsMinTabletSize();
  return (
    <div {...props}>
      {React.Children.map(children, (child, index) => {
        return (
          <>
            {child}
            {index < childrenCount - 1 && (
              <SummaryDivider orientation={isMinTablet ? "vertical" : "horizontal"} flexItem />
            )}
          </>
        );
      })}
    </div>
  );
})(({ theme }) => ({
  display: "flex",
  width: "100%",
  [theme.breakpoints.down("tablet")]: {
    flexFlow: "column",
  },
}));
const SummaryDivider = styled(Divider)(({ theme }) => ({
  margin: "24px 0",

  [theme.breakpoints.up("tablet")]: {
    margin: "0 24px",
  },
}));
const SummaryColumn = styled("div")({
  display: "flex",
  flexFlow: "column",
  flex: "1",
  gap: "24px",
  // Custom css for this instance in case we separate the component:
  wordBreak: "break-word",
});
